import React, { useEffect } from "react";
import useEventDetailsGrid from "@hooks/useEventDetailsGrid";
import { Message } from "semantic-ui-react";
import CustomerInteractionContainer from "@components/Compliance/forms/CustomerInteractionContainer";
import AgeVerificationContainer from "@components/Compliance/forms/AgeVerificationContainer";
import ObservationContainer from "@components/Compliance/forms/ObservationContainer";
import UnresolvedDisputeContainer from "@components/Compliance/forms/UnresolvedDisputeContainer";
import useIncidentContainer from "@hooks/useIncidentContainer";
import useComplianceView from "@hooks/useComplianceView";
import SuspiciousActivityContainer from "../forms/SuspiciousActivityContainer.js";
import CustomerIncidentContainer from "../forms/CustomerIncidentContainer.js";
import EnforcementVisitContainer from "../forms/EnforcementVisitContainer.js";
import SelfExclusionContainer from "../forms/SelfExclusionContainer.js";
import AgcCheckContainer from "../forms/AgcCheckContainer.js";

const INCIDENT_TYPE = "Incident";
const CUSTOMER_INTERACTION_TYPE = "Customer Interaction";
const AGE_VERFIFICATION_TYPE = "Age Verification";
const OBSERVATION_TYPE = "Observation";
export const SELF_EXCLUSION_TYPE = "Self Exclusion";
export const AGC_CHECK_TYPE = "AGC Check";

export const SUSPICIOUS_ACTIVITY_TYPE = "Suspicious Activity";
export const CUSTOMER_INCIDENT_TYPE = "Customer Incident";
export const GAMBLING_DISPUTE_TYPE = "Gambling Dispute";
export const ENFORCEMENT_VISIT_TYPE = "Enforcement Visit";

const IncidentContainer = () => {
  const { onRowUpdate } = useIncidentContainer();
  const {
    activeRow: {
      event: { id },
    },
  } = useEventDetailsGrid();
  const {
    incident: {
      record,
      record: {
        incidentType: { name },
      },
    },
  } = useComplianceView();

  useEffect(onRowUpdate, [id]);

  if (!name) {
    return <></>;
  }

  switch (name) {
    case SUSPICIOUS_ACTIVITY_TYPE:
      return <SuspiciousActivityContainer key={record.id} />;

    case GAMBLING_DISPUTE_TYPE:
      return <UnresolvedDisputeContainer key={id} />;

    case CUSTOMER_INCIDENT_TYPE:
      return <CustomerIncidentContainer key={id} />;

    case ENFORCEMENT_VISIT_TYPE:
      return <EnforcementVisitContainer key={id} />;

    default:
      return <Message error>No form for this incident type.</Message>;
  }
};

const FormContainer = () => {
  const { activeRow } = useEventDetailsGrid();

  const {
    event: { name },
  } = activeRow;

  if (!name) {
    return <></>;
  }

  switch (name) {
    case INCIDENT_TYPE:
      return <IncidentContainer />;

    case CUSTOMER_INTERACTION_TYPE:
      return <CustomerInteractionContainer />;

    case AGE_VERFIFICATION_TYPE:
      return <AgeVerificationContainer />;

    case OBSERVATION_TYPE:
      return <ObservationContainer />;

    case SELF_EXCLUSION_TYPE:
      return <SelfExclusionContainer />;

    case AGC_CHECK_TYPE:
      return <AgcCheckContainer />;

    default:
      return <Message error>Form not implemented</Message>;
  }
};

const EventDetailsForm = () => {
  const {
    activeRow,
    activeRow: { id },
  } = useEventDetailsGrid();

  if (!activeRow) {
    return <></>;
  }

  return (
    <div className="p-1 table-overflow flex-stretch-vertical">
      <FormContainer key={id} />
    </div>
  );
};

export default EventDetailsForm;
